import { Paragraph, SquaredSwatch } from '@joor/design-system'
import styled from 'styled-components/macro'

import { encodeURIComponentImageName, getSizedImageUrl } from 'utils/images'

export function SwatchInfo({ hex, imageUrl, name }: Props) {
  return (
    <Holder>
      <SquaredSwatch
        hex={hex}
        imageUrl={getSizedImageUrl(
          encodeURIComponentImageName(imageUrl),
          '40x40',
        )}
      />
      <Paragraph type="3" typeface="montserrat" className="notranslate">
        {name}
      </Paragraph>
    </Holder>
  )
}

type Props = {
  hex: string
  imageUrl: string
  name: string
}

const Holder = styled.div`
  width: 120px;
  display: flex;
  align-items: center;
  gap: 4px;

  p {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`
